var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterviewed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "task"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 2.9834H6C4.9 2.9834 4.01 3.88204 4.01 4.98038L4 20.9563C4 22.0546 4.89 22.9533 5.99 22.9533H18C19.1 22.9533 20 22.0546 20 20.9563V8.97436L14 2.9834ZM18 20.9563H6V4.98038H13V9.97285H18V20.9563ZM8.82 14.0167L7.4 15.4246L10.94 18.9593L16.6 13.3078L15.19 11.8999L10.95 16.1335L8.82 14.0167Z",
    fill: "#F5AD55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterviewed);
export default __webpack_public_path__ + "static/media/interviewed.dc7d226ad85d82d2588653877b4fa010.svg";
export { ForwardRef as ReactComponent };